module.exports = __webpack_public_path__ + "media/images/emblems/Huttwil-coat_of_arms-c22ebb318ae1ec1c46fb686c3fcb718b.svg";